var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1003",
    fillOpacity: 0.5,
    d: "M7.5 2h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-10a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-10Zm2 1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1 0-2Zm0 12h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2Zm0-4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2Zm0-4h6a1 1 0 1 1 0 2h-6a1 1 0 0 1 0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resumeIcon.21e66b9e70332fdf1b4ac26c6b648553.svg";
export { ForwardRef as ReactComponent };